import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames/bind';
import moment from 'moment';

import Search from '../Search/Search';

import { FlightCardListSmall, FlightCardSmall } from '../FlightCardList/FlightCardList';

import FlightCardListLarge from '../FlightCardListLarge/FlightCardListLarge';

import styles from './FlightsHomeDates.module.css';

const cx = classNames.bind(styles);


const virginFlightCarouselData = {
  airline: 'virgin',
  price: 1285,
  duration: '14h 40m',
  numberOfFlights: 1,
  departure: 'Fri 7:15am',
  arrival: 'Mon 9:15am',
  cards: [
    {
      text: "Extra legroom for extra comfort",
      video: 'virgin',
      image: null,
    },
    {
      text: "",
      image: 'virgin_card_1.jpg',
    },
    {
      text: "Sydney Airport",
      image: 'virgin_card_2.jpg',
    },
    {
      text: "Lounge to Seat Baggage Delivery",
      image: 'virgin_card_3.jpg',
    },
    {
      text: "In-flight Entertainment",
      image: 'virgin_card_4.jpg',
    },
    {
      text: "Muir Lounge",
      image: 'virgin_card_5.jpg',
    }
  ]
}

const unitedFlightCarouselData = {
  airline: 'united',
  price: 280,
  duration: '14h 40m',
  numberOfFlights: 1,
  departure: 'Fri 7:15am',
  arrival: 'Mon 9:15am',
  cards: [
    {
      text: "Flights with exceptional meal service",
      video: 'united',
      image: null,
    },
    {
      text: "",
      image: 'united_card_1.jpg',
    },
    {
      text: "Sydney Airport",
      image: 'united_card_2.jpg',
    },
    {
      text: "Custom Meal Options",
      image: 'united_card_3.jpg',
    },
    {
      text: "In-flight Entertainment",
      image: 'united_card_4.jpg',
    },
    {
      text: "Yosemite Lounge",
      image: 'united_card_5.jpg',
    }
  ]
}

const surfAirFlightCarouselData = {
  airline: 'surfair',
  price: 280,
  duration: '1h 10m',
  numberOfFlights: 3,
  departure: 'Fri 7:15am',
  arrival: 'Mon 9:15am',
  cards: [
    {
      text: "Arrive in style from Oakland",
      video: 'surfair',
      image: null,
    },
    {
      text: "Land in Santa Barbara Airport",
      image: 'surfair_card_1.png',
    },
    {
      text: 'Pilatus PC 12',
      image: 'surfair_card_2.png',
    },
    {
      text: 'Breakfeast & Wifi',
      image: 'surfair_card_3.png',
    },
    {
      text: "Free parking at the airport",
      image: 'surfair_card_4.png'
    },
  ]
}

const jetSuiteFlightCarouselData = {
  airline: 'jetsuite',
  price: 240,
  duration: '1h 10m',
  numberOfFlights: 5,
  departure: 'Fri 7:15am',
  arrival: 'Mon 9:15am',
  cards: [
    {
      text: "Speed and value from San Jose",
      video: 'jetSuite',
      image: null,
    },
    {
      text: "Airbnb Lounge",
      image: 'jetsuite_card_1.png',
    },
    {
      text: "Land in Santa Barbara Airport",
      image: 'jetsuite_card_2.png',
    },
    {
      text: `Embraeur \n135`,
      image: 'jetsuite_card_3.png',
    },
    {
      text: 'Snacks & Drinks',
      image: 'jetsuite_card_4.png',
    }
  ]
}

class FlightsHomeDates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      watchSelected: false,
      sortCards: false,
    };
    this.onWatchClick = this.onWatchClick.bind(this);
    this.onSort = this.onSort.bind(this);
  }

  onWatchClick() {
    this.setState({ watchSelected: !this.state.watchSelected });
  }

  onSort() {
    this.setState({ sortCards: !this.state.sortCards });
  }

  render() {
    const { direction } = this.props.match.params;
    const switchThumbStyles = cx({
      switchThumb: true,
      selected: this.state.watchSelected,
    });

    const switchStyles = cx({
      switch: true,
      selected: this.state.watchSelected,
    });

    const cardSortButtonStyle = cx({
      cardSort: true,
      up: this.state.sortCards,
    });

    return (
      <div className={styles.flightHomeDates}>
        <Search/>

        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>

        {direction === 'return' ? 

          <div>
            <h2>Outbound Flight</h2>
            <FlightCardSmall direction={direction} airline={this.props.isLongHaul ? 'virgin' : 'surfairOutbound'}/>
            <br />
          </div>

        : null}
        <h2>Popular {this.props.match.params.direction} Flights</h2>
        <div className={styles.flightCardWrapper}>
          <FlightCardListLarge direction={direction} flightData={this.props.isLongHaul ? virginFlightCarouselData : surfAirFlightCarouselData } />
          <FlightCardListLarge direction={direction} flightData={this.props.isLongHaul ? unitedFlightCarouselData : jetSuiteFlightCarouselData}/>
        </div>
        <div className={styles.watchWrapper} onClick={this.onWatchClick} >
          <div className={switchStyles} >
            <div className={switchThumbStyles} />
          </div>
          <h1>Watch this trip</h1>
          <p>We can let you know if any last minute offer happens or if tickets start selling out quickly</p>
          <hr />
          <h2>Advanced options</h2>
          <p className={styles.advanced}>Flexible dates, personal preferences</p>
        </div>
        <h3>{`Other ${direction} flights`}</h3>
        <div className={cardSortButtonStyle} onClick={this.onSort}>{"Value"}</div>
        <FlightCardListSmall count={7} sorted={this.state.sortCards} direction={direction} />
      </div>
    );
  }
}

const mapStateToProps = ({ main }) => ({
  isLongHaul: main.isLongHaul,
  startDate: main.startDate ||  moment().day(5 + 7),
  endDate: main.endDate ||  moment().day(7 + 7),
});

export default withRouter(connect(mapStateToProps)(FlightsHomeDates));



// WEBPACK FOOTER //
// ./src/components/FlightsHomeDates/FlightsHomeDates.jsx